/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LineOaFinancierConnectionConfig = {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    financierId?: string;
    channelAccessToken?: string;
    richMenuId?: string;
    contactInfoType?: LineOaFinancierConnectionConfig.contactInfoType;
    contactInfo?: string;
    enabled?: boolean;
    webhookUrlPath?: string;
};
export namespace LineOaFinancierConnectionConfig {
    export enum contactInfoType {
        CUSTOM_LINK = 'CUSTOM_LINK',
        LINE_OA_CHAT = 'LINE_OA_CHAT',
    }
}

